"use client";

import PointsLoader from "@/app/(components)/generics/loaders/PointsLoader/PointsLoader";
import { Limits } from "@/app/vars/Limits";
import styles from "./ModalLoader.module.css";

export default function ModalLoader() {
  return (
    <div className={styles.loader}>
      <PointsLoader centered color="var(--color-green-3)" delay={Limits.MODAL_LOADER_DELAY} />
    </div>
  );
}
